<template>
    <div>
        <BodycheckTaocan />
    </div>
</template>

<script>
import BodycheckTaocan from "./bodycheckTaocanView.vue";
export default {
    components: {
        BodycheckTaocan,
    },
    data() {
        return{
            
        }
    },
    created(){
        
    }
};
</script>
